'use strict';
/*
* Use this file to call functions in other files, on document ready, window.resize etc.
*/
var twentyninetimes = twentyninetimes || {};

// Document ready
document.addEventListener('DOMContentLoaded', function(){

    setTimeout(function() {
        svg4everybody(); // Fix SVG spritemap in IE/Edge
    });

    // Slice page title and wrap every word in spans
    var page_title  = document.querySelector('h1');
    if ( page_title ) {
        var new_title   = page_title.innerHTML.replace(/([A-Za-z0-9\!\@\#\$\%\^\&\’\;\´\‘\’\<br>\*\)\(+\=\._-]+)/g, '<span class="word-wrap"><span>$1</span></span>');

        page_title.innerHTML = new_title;
    }

    twentyninetimes.navigation.init();
    twentyninetimes.accordion.init();
    twentyninetimes.slider.init();
    twentyninetimes.loadMore.init();
    twentyninetimes.modal.init();
    twentyninetimes.timeline.init();
    twentyninetimes.tabbed.init();
    //twentyninetimes.pageTransition.init();
    

    //check if url has parameter job, if so, scroll to it
    var urlParams = new URLSearchParams(window.location.search);
    var job = urlParams.get('job');
    if ( job ) {
        var job_element = document.getElementById('hibob-job-' + job);
        if ( job_element ) {
            var offset = job_element.offsetTop - 120;
            window.scrollTo({
                top: offset,
                behavior: 'smooth'
            });
        }
    }

    anime({
        targets: '.blocks-container .container-inside h1',
        opacity: [0, 1],
        easing: 'easeOutQuart',
        loop: false,
        duration: 1250
    });

    anime({
        targets: '.blocks-container .container-inside h1 > span > span',
        translateY: ['100%', 0],
        delay: anime.stagger(50),
        easing: 'easeOutQuart',
        loop: false,
        duration: 1250
    });

    anime({
        targets: '.blocks-container .container-inside h1 ~ p.has-preamble-font-size, h1 ~ p.has-preamble-font-size ~ .wp-block-buttons',
        opacity: [0, 1],
        translateY: [20, 0],
        delay: anime.stagger(100, {start: 650}),
        easing: 'easeOutQuart',
        loop: false,
        duration: 1500
    });
});

// Functions to be run when the entire site has been loaded
// window.onload = function() {	
// 	twentyninetimes.pageTransition.pageTransitionIn();
// }
